export const SMART_REDIRECT_PATH = `redirect`;
